import Button, {
  ButtonPropsColorOverrides,
  ButtonPropsVariantOverrides
} from '@mui/material/Button';
import { SxProps } from '@mui/system/styleFunctionSx';
import { OverridableStringUnion } from '@mui/types';

interface Props {
  id?: string;
  color?: OverridableStringUnion<
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning',
    ButtonPropsColorOverrides
  >;
  variant?: OverridableStringUnion<
    'text' | 'outlined' | 'contained',
    ButtonPropsVariantOverrides
  >;
  disabled?: boolean;
  onClick?: () => void;
  sx?: SxProps;
  fullWidth?: boolean;
  children: string;
  testId?: string;
  // Stable RUM action name (data-dd-action-name). Set on key CTAs so replay masking doesn't
  // record clicks as "Masked Element" — makes dead/rage clicks groupable in Datadog.
  dataActionName?: string;
}

export const AppButton = ({
  id,
  color,
  fullWidth,
  variant,
  disabled,
  onClick,
  sx,
  testId = 'app-button',
  dataActionName,
  children
}: Props) => {
  return (
    <Button
      id={id}
      data-testid={testId}
      data-dd-action-name={dataActionName}
      size="large"
      fullWidth={fullWidth}
      color={color}
      variant={variant ?? 'contained'}
      onClick={onClick}
      disabled={disabled}
      sx={{
        display: 'block',
        height: 40,
        width: fullWidth ? '100%' : '50%',
        ...(fullWidth ? {} : { maxWidth: 300 }),
        px: 0.5,
        fontSize: '14px',
        textAlign: 'center',
        lineHeight: 'normal',
        borderRadius: 1.5,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '@media (max-width: 374px)': {
          fontSize: '12.5px'
        },
        ...sx
      }}
    >
      {children}
    </Button>
  );
};
